import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const DateCalculatorPage = () => {
  const [calcType, setCalcType] = useState('difference');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [daysToAdd, setDaysToAdd] = useState('');
  const [result, setResult] = useState(null);

  const calculate = () => {
    if (calcType === 'difference' && startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = end - start;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      const diffWeeks = Math.floor(diffDays / 7);
      const diffMonths = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
      const diffYears = end.getFullYear() - start.getFullYear();

      setResult({ type: 'difference', days: diffDays, weeks: diffWeeks, months: diffMonths, years: diffYears });
    } else if (calcType === 'add' && startDate && daysToAdd) {
      const start = new Date(startDate);
      const days = parseInt(daysToAdd);
      const resultDate = new Date(start);
      resultDate.setDate(resultDate.getDate() + days);

      setResult({ type: 'add', resultDate: resultDate.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) });
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Date Calculator</span>
          </nav>
          <h1 className="text-3xl font-bold text-white mb-2">Date Calculator</h1>
          <p className="text-gray-400 mb-8">Calculate the difference between dates or add days to a date.</p>

          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
            <div className="flex gap-4 mb-5">
              <button onClick={() => setCalcType('difference')} className={`px-4 py-2 rounded-lg font-medium ${calcType === 'difference' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Date Difference</button>
              <button onClick={() => setCalcType('add')} className={`px-4 py-2 rounded-lg font-medium ${calcType === 'add' ? 'bg-cyan-600 text-white' : 'bg-[#2a2a2a] text-gray-400'}`}>Add/Subtract Days</button>
            </div>
            {calcType === 'difference' ? (
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">Start Date</label>
                  <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]" />
                </div>
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">End Date</label>
                  <Input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]" />
                </div>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 gap-5">
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">Start Date</label>
                  <Input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white [color-scheme:dark]" />
                </div>
                <div>
                  <label className="block text-gray-300 mb-2 font-medium">Days to Add (use negative to subtract)</label>
                  <Input type="number" value={daysToAdd} onChange={(e) => setDaysToAdd(e.target.value)} className="w-full bg-[#0d0d0d] border-[#2a2a2a] text-white" placeholder="30" />
                </div>
              </div>
            )}
            <Button onClick={calculate} className="mt-5 bg-cyan-600 hover:bg-cyan-500 text-white">Calculate</Button>
            {result && (
              <div className="mt-6 p-5 bg-[#0d0d0d] border border-[#2a2a2a] rounded-xl">
                {result.type === 'difference' ? (
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="p-4 bg-cyan-500/10 border border-cyan-500/30 rounded-lg text-center"><span className="text-gray-400 text-sm">Days</span><p className="text-2xl font-bold text-cyan-400">{result.days}</p></div>
                    <div className="p-4 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">Weeks</span><p className="text-xl font-bold text-white">{result.weeks}</p></div>
                    <div className="p-4 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">Months</span><p className="text-xl font-bold text-white">{result.months}</p></div>
                    <div className="p-4 bg-[#1a1a1a] rounded-lg text-center"><span className="text-gray-500 text-sm">Years</span><p className="text-xl font-bold text-white">{result.years}</p></div>
                  </div>
                ) : (
                  <div className="text-center">
                    <span className="text-gray-400">Result Date</span>
                    <p className="text-2xl font-bold text-cyan-400">{result.resultDate}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DateCalculatorPage;
